import React, { PureComponent } from "react";
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, Cell, XAxis, YAxis, Tooltip } from "recharts";

import numeral from "numeral";

import styles from "./style.module.css";

const CustomToolTip = (props) => {
  const { active, payload, unit, isCurrencyUnit } = props;
  if (!active || !payload) {
    return null;
  }

  const dataKey = payload[0] && payload[0].dataKey;
  const retPayload = payload[0] && payload[0].payload;

  if (!retPayload) {
    return null;
  }

  return (
    <div className={styles.cTooltip} style={{ fontSize: "14px", color: "#333" }}>
      <div>
        <strong>{retPayload.label}</strong>
      </div>
      <div>
        {isCurrencyUnit ? <span>{unit}</span> : <span />}
        {numeral(retPayload[dataKey]).format("0,0.[0]")}
        {!isCurrencyUnit ? <span style={{ marginLeft: "5px" }}>{unit}</span> : <span />}
      </div>
    </div>
  );
};

export default class DoubleOutcomeChart extends PureComponent {
  render() {
    const { fields, isSmall, colorOne, hideChart, shouldLog, dataset } = this.props;

    const outcome = dataset ? dataset.outcome : undefined;

    const constraint = fields[1].data[0].value;
    const notLabel = outcome + " when not " + constraint;

    const data = fields[0].data.map((d) => {
      return {
        [fields[0].label]: d.value,
        [outcome]: 2,
        [notLabel]: 1
      };
    });

    return (
      <div className={styles.outcomeChart}>
        {isSmall !== true && (
          <div className={styles.boldItem} style={{ width: "100%", marginLeft: "10px" }}>
            {fields[0].label + " when " + fields[1].label + " is " + fields[1].data[0].value}
          </div>
        )}
        {hideChart !== true && (
          <ResponsiveContainer>
            <BarChart data={data} margin={{ top: 10, bottom: 10, right: 10, left: 10 }}>
              {isSmall !== true && <CartesianGrid strokeDasharray="3 3" />}
              <XAxis
                dataKey={fields[0].label}
                label={{
                  value: fields[0].label,
                  position: "insideBottom",
                  offset: 0
                }}
                hide={isSmall}
              />
              <YAxis
                dataKey={outcome}
                label={{
                  value: outcome,
                  position: "insideLeft",
                  angle: -90
                }}
                domain={["auto", "auto"]}
                hide={isSmall}
              />
              <Tooltip cursor={{ strokeDasharray: "3 3" }} />
              <Bar dataKey={outcome}>{data && data.map((p, index) => <Cell key={index} fill={colorOne} />)}</Bar>
              <Bar dataKey={notLabel}>{data && data.map((p, index) => <Cell key={index} fill={"#c9c9c9"} />)}</Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    );
  }
}
